import React, { useState } from 'react';

const FeatureTabs = () => {
  const [activeTab, setActiveTab] = useState('Order Control');

  const tabs = [
    'Smart Posting',
    'Auto Replies',
    'DM Selling',
    'Instant Pay',
    'Label Generation',
    'Order Control',
    'Smart Shipping',
    'WhatsApp Flow'
  ];

  const scrollToFeature = (index) => {
    const id = `feature-${index + 1}`;
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // Account for sticky header
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="py-12 lg:py-16 bg-white dark:bg-gray-900 border-b border-gray-100 dark:border-gray-800 transition-colors duration-300">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-black text-gray-900 dark:text-white mb-3">Run your entire Instagram business in one place</h2>
          <p className="text-lg text-gray-500 dark:text-gray-400">From first comment to final delivery, ReelTale automates everything.</p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 lg:gap-8">
          {tabs.map((tab, index) => (
            <button
              key={tab}
              onClick={() => {
                setActiveTab(tab);
                scrollToFeature(index);
              }}
              className={`pb-4 px-2 text-sm lg:text-base font-bold transition-all relative whitespace-nowrap ${
                activeTab === tab 
                ? 'text-gray-900 dark:text-white' 
                : 'text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300'
              }`}
            >
              {tab}
              {activeTab === tab && (
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-sky-400 rounded-full"></div>
              )}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureTabs;
